import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// native components
import AdvisorConnectCardSimplified from '../../../../components/advisorConnectCardSimplified';

export default () => {
  return (
    <AdvisorConnectCardSimplified
      id='working-with-an-advisor'
      backgroundVariant='lightC'
      headingText={<>Ready to take the next step with a <WidowBlock>financial advisor&#63;</WidowBlock></>}
      text={<>We&#39;ll match you with an advisor based on their expertise, location, and the age group they often work with, so they&#39;ll be best suited to understand you and your needs.</>}
    />
  );
};
